<template>
  <div id="content-setting">
    <div class="ipub-h1 mar-b-24 line-h-40 relative">
      Content Setting
    </div>
    <ipub-row :gutter="[20,20]">
      <ipub-col :span="9">
        <div class="ipub-p1 fw-400 mar-b-24">
          <ipub-row> Here you can upload files for download. Supported file types: pdf; doc; docx; txt; png; jpg; jpeg; tif; tiff; html; xls; xlsx; mp4; mp3; mov; zip.</ipub-row>
          <ipub-row> <strong>Note：</strong> If you want to include a file in a website page, copy and paste the link cell.</ipub-row>
        </div>
      </ipub-col>
      <ipub-col :span="3"
                v-if="user.codeList&&user.codeList.includes('SYSTEM.CONTENT_SETTING.FILES.UPLOAD')"
                class="relative">
        <div class="ipub-p1 right-option">
          <ipub-upload @change="handleUpload"
                       class="mar-l-20">
            <ipub-button type="primary"
                         :loading="loading"
                         plain>
              Upload Files
            </ipub-button>
          </ipub-upload>
        </div>
      </ipub-col>
    </ipub-row>
    <div class=" mar-b-20">
      <ipub-row :gutter="[12,12]">
        <ipub-col :span="12">
          <site-search-group v-model.trim="params.keyword"
                             placeholder="Search for File Name"
                             @search="getList()"
                             @clear="handleClear" />
        </ipub-col>
      </ipub-row>
    </div>
    <div>
      <ipub-table :columns="columns"
                  fixed
                  :empty="{icon:'iconmail'}"
                  :pagination="pagination"
                  @order="onOrderChanage"
                  :dataSource="dataSource">
        <template v-slot:path="{ text }">
          <template v-if="text">
            <ipub-tooltip style="width:100%"
                          placement="bottomLeft">
              <div slot="title"> {{text}} </div>
              <div class="flex">
                <div class="omis">{{text}}</div>
              </div>
            </ipub-tooltip>
            <ipub-tooltip class="tooltip-box-item"
                          placement="bottomLeft">
              <div slot="title">Copy to clipboard</div>
              <ipub-icon type="iconduplicate ipub-c-p"
                         @click="handleCopyAddress(text)" />
            </ipub-tooltip>

          </template>

          <template v-else>- -</template>
        </template>
        <template v-slot:date="{ record }">
          {{$moment(record.operatorTime?record.operatorTime:(record.updateTime?record.updateTime:record.createTime)).format('HH:mm DD / MM / YYYY')}}
        </template>
        <template v-slot:actions="{ record }">

          <ipub-tooltip class="border-right"
                        v-show="user.codeList&&user.codeList.includes('SYSTEM.CONTENT_SETTING.FILES.UPDATE')">
            <div slot="title">Update</div>
            <ipub-upload @change="(e)=>{handleUpdate(record, e)}">
              <a>
                <ipub-icon type="iconupload" />
              </a>
            </ipub-upload>
          </ipub-tooltip>

          <ipub-tooltip class="border-right"
                        v-show="user.codeList&&user.codeList.includes('SYSTEM.CONTENT_SETTING.FILES.DOWNLOAD')">
            <div slot="title">Download</div>
            <ipub-icon type="icona-ExportReviewcomments"
                       @click="download(record)" />
          </ipub-tooltip>

          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.CONTENT_SETTING.FILES.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>

        </template>
      </ipub-table>

    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
